// Mock data for Life With Abba landing page clone.
// NOTE: All content below is mocked/static for the frontend-only build.

export const IMG = {
  logo: "/assets/img/logo.png",
  miniLogo: "/assets/img/mini-logo.png",
  dot: "/assets/img/dot.png",
  apple: "/assets/img/apple.png",
  android: "/assets/img/android.png",
  phone: "/assets/img/phone-2.png",
  heroPhone: "/assets/img/hero-phone.png",
  woman: "/assets/img/woman.png",
  man: "/assets/img/man.png",
};

export const NAV_LINKS = [
  { label: "Features", to: "/#features" },
  { label: "Pricing", to: "/#pricing" },
  { label: "Blog", to: "/blog" },
  { label: "Shop", to: "/shop" },
];

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/lifewithabba/id1536421989";

export const EXPLAINER_BOXES = [
  {
    title: "Get Social",
    body:
      "Social media lets us share life digitally with others. The Life With Abba app lets you share life digitally with Abba, your Heavenly Father!",
  },
  {
    title: "Go Deeper",
    body:
      "By sharing daily experiences, verses, prayers, mood, and thoughts with Abba, it\u2019s our hope and prayer that this will contribute to a closer, deeper relationship with Him!",
  },
  {
    title: "Have Faith",
    body:
      "While others won't see your content, we believe Abba will engage your heart and mind as you use the Life With Abba app to socialize with Him, \"social media style.\"",
  },
];

// icon key maps to a lucide-react icon in Features.jsx
export const FEATURES_LEFT = [
  {
    icon: "camera",
    accent: true,
    title: "Capture Moments",
    body:
      "A photo is worth a thousand words. A Video...thousands! Capture moments as photos or short videos! Abba\u2019s watching!",
  },
  {
    icon: "bible",
    accent: false,
    title: "The Word Of God!",
    body:
      "His word teaches us truth, righteousness, and correction. Abba loves it when we meditate on His Word througout our day!",
  },
  {
    icon: "pen",
    accent: false,
    title: "Power Of The Pen!",
    body:
      "Abba has been inspiring writers throughout the ages. He even writes His law on our hearts. Abba\u2019s listening!",
  },
];

export const FEATURES_RIGHT = [
  {
    icon: "mic",
    accent: true,
    title: "Record Your Vocals",
    body:
      "Speak your thoughts, sing a song, share a spoken word or poem, or simply pray out loud ... to Abba!",
  },
  {
    icon: "smile",
    accent: false,
    title: "What\u2019s Your Mood?",
    body:
      "Sometimes it\u2019s hard to find the words. Simply express your moods with an emoji! Abba understands!",
  },
  {
    icon: "plus",
    accent: true,
    title: "Go Ahead, Share With Abba!",
    body:
      "You\u2019re probabaly already used to using social media. Now, use those modern, digital skills to share your life with Abba!",
  },
];

const COMMON_FEATURES = [
  "No Ads",
  "Unlimited secure cloud backup",
  "Use offline *",
  "Passcode and biometric security",
  "End-to-end encryption for privacy",
  "Unlimited Scripture Posts",
  "Unlimited Write Posts",
  "Unlimited Emoji Posts",
  "Unlimited Photo Posts",
  "Unlimited Video Posts",
  "Unlimited Audio Recording Posts",
  "Synced across all your devices",
  "Accounts for up to 6 Apple ID Family Members",
];

// value: true = check, false = x, string = label (e.g. '1st 30 Days Only')
export const PLAN_ROWS = COMMON_FEATURES.map((label) => ({ label }));

export const PLANS = [
  {
    name: "Basic",
    price: "$0",
    highlight: false,
    values: {
      "No Ads": true,
      "Unlimited secure cloud backup": true,
      "Use offline *": true,
      "Passcode and biometric security": true,
      "End-to-end encryption for privacy": true,
      "Unlimited Scripture Posts": true,
      "Unlimited Write Posts": true,
      "Unlimited Emoji Posts": true,
      "Unlimited Photo Posts": "1st 30 Days Only",
      "Unlimited Video Posts": "1st 30 Days Only",
      "Unlimited Audio Recording Posts": "1st 30 Days Only",
      "Synced across all your devices": "1st 30 Days Only",
      "Accounts for up to 6 Apple ID Family Members": false,
    },
  },
  {
    name: "Premium",
    price: "$3.49/mo",
    subPrice: "or $34.99/year",
    highlight: true,
    values: {
      "No Ads": true,
      "Unlimited secure cloud backup": true,
      "Use offline *": true,
      "Passcode and biometric security": true,
      "End-to-end encryption for privacy": true,
      "Unlimited Scripture Posts": true,
      "Unlimited Write Posts": true,
      "Unlimited Emoji Posts": true,
      "Unlimited Photo Posts": true,
      "Unlimited Video Posts": true,
      "Unlimited Audio Recording Posts": true,
      "Synced across all your devices": true,
      "Accounts for up to 6 Apple ID Family Members": false,
    },
  },
  {
    name: "Family",
    price: "$9.99/mo",
    subPrice: "or $99/year",
    highlight: true,
    dark: true,
    values: {
      "No Ads": true,
      "Unlimited secure cloud backup": true,
      "Use offline *": true,
      "Passcode and biometric security": true,
      "End-to-end encryption for privacy": true,
      "Unlimited Scripture Posts": true,
      "Unlimited Write Posts": true,
      "Unlimited Emoji Posts": true,
      "Unlimited Photo Posts": true,
      "Unlimited Video Posts": true,
      "Unlimited Audio Recording Posts": true,
      "Synced across all your devices": true,
      "Accounts for up to 6 Apple ID Family Members": true,
    },
  },
];

export const TESTIMONIALS = [
  {
    title: "Believe Me, It Works!",
    body:
      "Loem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    name: "Denikia",
    from: "GA, USA",
    avatar: IMG.woman,
  },
  {
    title: "Wow. Just Wow!",
    body:
      "Loem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    name: "Vernon",
    from: "GA, USA",
    avatar: IMG.man,
  },
  {
    title: "A Beautiful Habit",
    body:
      "Loem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    name: "Marcus",
    from: "TX, USA",
    avatar: IMG.man,
  },
  {
    title: "Closer To Him",
    body:
      "Loem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
    name: "Rebecca",
    from: "FL, USA",
    avatar: IMG.woman,
  },
];

export const FOOTER = {
  getApp: ["iPhone", "iPad", "Web Browser (TBD)"],
  offers: ["Features", "Pricing"],
  about: ["About LWA", "Press", "Terms", "Privacy"],
  help: ["FAQs", "Contact Us", "Facebook Group"],
  social: ["Facebook", "Instagram", "Twitter", "TruthSocial"],
};
